import React from "react";
import { Typography, Box } from "@material-ui/core";
import { ActivityAvatar } from "./ActivityListItemAvatar";

export const ActivitySummaryCell: React.FC<{
  icon: React.ReactNode;
  summary: string;
  isGrey: boolean;
}> = ({ icon, summary, isGrey }) => {
  return (
    <Box display="flex" alignItems="top">
      <ActivityAvatar isPending={isGrey}>{icon}</ActivityAvatar>
      <Box ml={1}>
        <Typography variant="body1">{summary}</Typography>
      </Box>
    </Box>
  );
};
